import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function TextDocumentIcon({ fill, height, width }: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon height={height ?? 24} viewBoxDimensions="0 0 24 24" width={width ?? 24}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M7 7.5h3.563"
          stroke="#FFF"
          strokeLinecap="round"
          strokeWidth="1.5"
          transform="translate(1)"
        />
        <path
          d="M21.487 5.582H17.8c-.234 0-.424-.19-.424-.424V1.75h-1.5v3.408c0 1.063.861 1.924 1.924 1.924H21.5V21c0 .76-.616 1.375-1.375 1.375h-16.5c-.76 0-1.375-.616-1.375-1.375V3.125c0-.76.616-1.375 1.375-1.375h13.791c.36 0 .704.14.96.39l2.709 2.643c.22.215.361.497.402.8zM6.417 9.375h7c.413 0 .75-.336.75-.75s-.337-.75-.75-.75h-7c-.415 0-.75.336-.75.75s.335.75.75.75zm0 4.125h11c.413 0 .75-.336.75-.75s-.337-.75-.75-.75h-11c-.415 0-.75.336-.75.75s.335.75.75.75zm0 4.125h11c.413 0 .75-.336.75-.75s-.337-.75-.75-.75h-11c-.415 0-.75.336-.75.75s.335.75.75.75z"
          fill={fill ?? IconColors.DarkBlue}
          transform="translate(1)"
        />
      </g>
    </SimpleIcon>
  );
}
